import Head from 'next/head';
import Layout from './layout';
import Spinner from './spinner';

interface Props {
  title: string;
}

const FallbackPage: React.FC<Props> = ({ title }) => (
  <Layout>
    <Head>
      <title>{title}</title>
    </Head>
    <div className='flex justify-center'>
      <Spinner />
    </div>
  </Layout>
);

export default FallbackPage;
